import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'

// Whenever we're showing tax inclusive prices (for regions that should show exclusive)
// we want price text to be green.
// Note: Tax is therefore inclusive if there is none!
function useHotelPriceColour(taxesAndFeesAmount: number): 'highlight' | undefined {
  const { showTaxExclusivePrices } = useContext(GeoContext)

  return (taxesAndFeesAmount === 0 && showTaxExclusivePrices) ? 'highlight' : undefined
}

export default useHotelPriceColour
